import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../utils/api';
import BottomNav from '../../../components/layout/BottomNav';
import ModuleStrip from '../../../components/layout/ModuleStrip';
import { useModule } from '../../../context/ModuleContext';

const G     = '#166534';
const LIGHT = '#DCFCE7';

// listingType can be 'rent', 'lease', or 'sale' — rent/lease are shown "/Month"
const isRecurring = (t) => t === 'rent' || t === 'lease';

const CATEGORIES = [
  { key:'farmland',   label:'Farmland',   emoji:'', img:'/icons/farmland.jpg' },
  { key:'orchard',    label:'Orchard',    emoji:'🌳', img:'/icons/orchard.jpg' },
  { key:'plantation', label:'Plantation', emoji:'🌴', img:'/icons/plantation.jpg' },
  { key:'greenhouse', label:'Greenhouse', emoji:'🏡', img:'/icons/greenhouse.jpg' },
  { key:'other',      label:'Other',      emoji:'🗺️', img:'/icons/other.jpg' },
];

// Shows the real image if it loads; falls back to the emoji if the file
// isn't there yet (e.g. before you've dropped the images into place).
function CategoryIcon({ img, emoji, alt }) {
  const [failed, setFailed] = useState(false);
  if (failed || !img) return <span style={{ fontSize:20 }}>{emoji}</span>;
  return (
    <img src={img} alt={alt} onError={() => setFailed(true)}
      style={{ width:'100%', height:'100%', objectFit:'cover', borderRadius:12, display:'block' }} />
  );
}

const LOOKING_FOR = [
  { key:'rental',   label:'Rental',   sub:'Rent or lease agricultural land', emoji:'🏠', img:'/icons/rental.jpg',   type:'lease' },
  { key:'sale',     label:'Sale',     sub:'Buy agricultural land',           emoji:'🏷️', img:'/icons/sale.jpg',     type:'sale'  },
  { key:'property', label:'Property', sub:'Explore all properties',         emoji:'📋', img:'/icons/property.jpg', type:''      },
];

export default function LandHomePage() {
  const navigate = useNavigate();
  const { switchModule } = useModule();
  const [listings, setListings] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [search,   setSearch]   = useState('');
  const [lookingFor, setLookingFor] = useState('rental');

  useEffect(() => {
    switchModule('land');
    loadListings();
    
  }, []);

  const loadListings = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/land?limit=4');
      setListings(data.listings || data.data || []);
    } catch { setListings([]); }
    finally { setLoading(false); }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (search.trim()) navigate('/land/listings?search=' + encodeURIComponent(search.trim()));
  };

  return (
    <div style={{ background:'#F5F7FA', minHeight:'40vh', paddingBottom:30, fontFamily:'Inter,system-ui,sans-serif' }}>

      {/* Header */}
      <div style={{ background:G, padding:2 }}>
        <ModuleStrip />

        <style>{`
          .search-input::placeholder { color: rgba(255,255,255,0.8); opacity: 1; }
          .search-input::-webkit-input-placeholder { color: rgba(255,255,255,0.8); }
          .search-input::-moz-placeholder { color: rgba(255,255,255,0.8); }
        `}</style>

        <div style={{ padding:0 }}>
          <form onSubmit={handleSearch} style={{ margin:'3px 18px 2px 12px' }}>
            <div style={{ background:'rgba(255,255,255,.18)', borderRadius:20, padding:'6px 15px', display:'flex', alignItems:'center', gap:8, border:'1px solid rgba(255,255,255,.25)' }}>
              <span style={{ fontSize:12 }}>🔍</span>
              <input
                className="search-input"
                type="text"
                placeholder="Search land, plots, farms..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={{ border:'none', outline:'none', flex:1, fontSize:13, color:'#fff', background:'transparent' }}
              />
              {search && (
                <button type="button" onClick={() => setSearch('')}
                  style={{ border:'none', background:'transparent', color:'#fff', fontSize:18, cursor:'pointer', padding:0 }}>×</button>
              )}
            </div>
          </form>
        </div>
      </div>

      <div style={{ padding:'5px 10px 0' }}>

        {/* Hero banner */}
        <div
          onClick={() => navigate('/land/listings')}
          style={{
            borderRadius:20, overflow:'hidden', marginBottom:20, position:'relative',
            height:170, cursor:'pointer',
            background:`linear-gradient(180deg, rgba(6,40,20,.35), rgba(6,40,20,.72)), url('/images/land.jpg') center/cover`,
          }}
        >
          <div style={{ position:'absolute', inset:0, display:'flex', flexDirection:'column', justifyContent:'flex-end', padding:16 }}>
            {/* <div style={{ fontSize:20, fontWeight:800, color:'white', lineHeight:1.25 }}>Find the Right Land for Your Agricultural Needs</div> */}
            {/* <div style={{ fontSize:12, color:'rgba(255,255,255,.85)', marginTop:4 }}>Rent, Lease or Buy agricultural land easily and safely</div> */}
            {/* <button
              onClick={e => { e.stopPropagation(); navigate('/land/listings'); }}
              style={{ marginTop:10, alignSelf:'flex-start', background:'white', color:G, border:'none', borderRadius:10, padding:'8px 16px', fontSize:12, fontWeight:700, cursor:'pointer' }}>
              Browse Land →
            </button> */}
          </div>
        </div>

        {/* What are you looking for */}
        <div style={{ fontSize:15, fontWeight:800, color:'#1a1a1a', marginBottom:12 }}>What are you looking for?</div>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10, marginBottom:22 }}>
          {LOOKING_FOR.map(o => {
            const active = lookingFor === o.key;
            return (
              <button key={o.key}
                onClick={() => { setLookingFor(o.key); navigate('/land/listings' + (o.type ? `?type=${o.type}` : '')); }}
                style={{
                  display:'flex', flexDirection:'column', alignItems:'center', gap:6,
                  borderRadius:14, padding:'14px 8px', textAlign:'center', cursor:'pointer',
                  border:`1.5px solid ${active ? G : '#E5E7EB'}`,
                  background: active ? LIGHT : 'white',
                }}>
                <div style={{ width:34, height:34, borderRadius:9, overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <CategoryIcon img={o.img} emoji={o.emoji} alt={o.label} />
                </div>
                <span style={{ fontSize:12, fontWeight:700, color:'#1a1a1a' }}>{o.label}</span>
                <span style={{ fontSize:9.5, color:'#9CA3AF', lineHeight:1.2 }}>{o.sub}</span>
              </button>
            );
          })}
        </div>

        {/* Popular categories */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
          <span style={{ fontSize:15, fontWeight:800, color:'#1a1a1a' }}>Popular Categories</span>
          <button onClick={() => navigate('/land/listings')} style={{ background:'none', border:'none', color:G, fontSize:12, fontWeight:700, cursor:'pointer' }}>View all →</button>
        </div>
        <div style={{ display:'flex', justifyContent:'space-between', marginBottom:22 }}>
          {CATEGORIES.map(c => (
            <div key={c.key} onClick={() => navigate('/land/listings?category=' + c.key)}
              style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:6, cursor:'pointer' }}>
              <div style={{ width:46, height:46, borderRadius:12, background:LIGHT, display:'flex', alignItems:'center', justifyContent:'center', overflow:'hidden' }}>
                <CategoryIcon img={c.img} emoji={c.emoji} alt={c.label} />
              </div>
              <span style={{ fontSize:10, color:'#374151', fontWeight:500 }}>{c.label}</span>
            </div>
          ))}
        </div>

        {/* Recent listings */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
          <span style={{ fontSize:15, fontWeight:800, color:'#1a1a1a' }}>Recent Listings</span>
          <button onClick={() => navigate('/land/listings')} style={{ background:'none', border:'none', color:G, fontSize:12, fontWeight:700, cursor:'pointer' }}>View all →</button>
        </div>

        {loading ? (
          <div style={{ height:110, background:'white', borderRadius:16, opacity:.5, marginBottom:20 }} />
        ) : listings.length === 0 ? (
          <div style={{ textAlign:'center', padding:'26px 0', color:'#9CA3AF', background:'white', borderRadius:16, marginBottom:20, border:'0.5px solid #E5E7EB' }}>
            <div style={{ fontSize:34, marginBottom:6 }}></div>
            <div style={{ fontSize:13 }}>No listings yet — be the first to add one</div>
            <button onClick={() => navigate('/land/add')}
              style={{ marginTop:10, background:G, color:'white', border:'none', borderRadius:10, padding:'8px 16px', fontSize:12, fontWeight:700, cursor:'pointer' }}>
              + Add Property
            </button>
          </div>
        ) : (
          <div style={{ display:'grid', gap:12, marginBottom:20 }}>
            {listings.slice(0, 4).map(item => (
              <div key={item._id} onClick={() => navigate(`/land/${item._id}`)}
                style={{ background:'white', borderRadius:16, overflow:'hidden', border:'0.5px solid #E5E7EB', display:'flex', cursor:'pointer' }}>
                <div style={{ width:100, height:100, background:LIGHT, flexShrink:0 }}>
                  {item.photos?.[0] && <img src={item.photos[0]} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />}
                </div>
                <div style={{ padding:10, flex:1 }}>
                  <div style={{ fontSize:13, fontWeight:700, color:'#1a1a1a' }}>{item.title}</div>
                  <div style={{ fontSize:11, color:'#9CA3AF', margin:'4px 0' }}> {item.address}</div>
                  <div style={{ fontSize:13, fontWeight:700, color:G }}>
                    ₹{item.price?.toLocaleString?.() || item.price}
                    {isRecurring(item.listingType) && <span style={{ fontSize:10, color:'#9CA3AF', fontWeight:400 }}> / Month</span>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <BottomNav />
    </div>
  );
}